import React from 'react';
import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import { List } from 'immutable';

import './style.scss';

const ParagraphDownloadList = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value'], '');
  const text = entity.getIn(['field_text', 0, 'processed'], '');
  const downloadSubtitle = entity.getIn(['field_subtitle', 0, 'value'], '');
  const links = entity.getIn(['field_download_links'], List());

  return (
    <Container className="ParagraphDownloadList">
      <div className="row">
        <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          {title && (
            <div className="ParagraphDownloadList__title">
              <h2>{title}</h2>
            </div>
          )}

          {text && (
            <div className="ParagraphDownloadList__text">
              <WysiwygField
                property="schema:text"
                html={text}
              />
            </div>
          )}

          {downloadSubtitle && (
            <div className="ParagraphDownloadList__downloadSubtitle">
              <h3 className="asH4">{downloadSubtitle}</h3>
            </div>
          )}

          {links.map((link) => {
            const linkTitle = link.get('title', '');
            const linkUrl = link.get('alias', link.get('uri', ''));

            return (
              <div className="ParagraphDownloadList__downloadLink" key={linkUrl}>
                <a href={linkUrl} rel="noreferrer" target="_blank">
                  <i className="icon icon-download icon-variant-1" />
                  {linkTitle}
                </a>
              </div>
            );

          })}

        </div>
      </div>
    </Container>
  );
};

export default ParagraphDownloadList;
